import angular from 'angular';

import tszScrollTop from './tsz-scroll-top';

const tszScrollTopModule = angular.module('tsz.components.tszScrollTop', [])
  .component('tszScrollTop', tszScrollTop);

export default tszScrollTopModule;



// WEBPACK FOOTER //
// ./src/components/tsz-scroll-top/tsz-scroll-top.module.js